const HERO_BG =
  "https://customer-assets-jt897jd0.emergentagent.net/job_85f16ffa-52c0-4810-b83b-02e1c3049cb5/artifacts/qmaeinh9_IMG_2289.JPG";

export default HERO_BG;
